export enum VideoProviders {
  Recruitee = 'recruitee',
  Google = 'google',
  Zoom = 'zoom',
  Teams = 'teams',
}
